import {
	Accordion,
	Select,
	styled,
	Typography,
} from "@mui/material";

export const DetailTypography = styled(Typography)(({ theme }) => ({
	fontWeight: 700,
	fontSize: "16px",
	textAlign: "center",
	color: theme.palette.primary.dark,
}));

export const DetailAccordion = styled(Accordion)(({ theme }) => ({
	border: `2px solid ${theme.palette.primary.main}`,
	borderRadius: "10px",
	borderBottomRightRadius: "10px !important",
	borderBottomLeftRadius: "10px !important",
	backgroundColor: "transparent",
	"&.MuiAccordion-root.Mui-expanded": {
		"& .MuiButtonBase-root.MuiAccordionSummary-root": {
			minHeight: "54px",
			borderBottom: `2px solid ${theme.palette.primary.main}`,
			"& .MuiAccordionSummary-content": {
				margin: "0px",
			},
		},
	},
}));

export const DetailSelect = styled(Select)(({ theme }) => ({
	width: "100%",
	maxWidth: "300px",
	height: "50px",
	"& .MuiSelect-select": {
		color: theme.palette.primary.dark,
		fontSize: "16px",
		fontWeight: 700,
		padding: "0px 18px",
	},
	"& .MuiOutlinedInput-notchedOutline": {
		border: `2px solid ${theme.palette.primary.main}`,
		borderRadius: "10px",
	},
}));
